module.exports = __webpack_public_path__ + "media/landing-video.8d77c48a.mp4";